<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <div class="grid_table" v-if="$store.state.userDetail.manage_units_create === 1">
        <div class="margin_right">
          <v-form ref="form" @submit.prevent="createUnit">
            <v-card>
              <div class="pl-4 pt-4">
                <span style="font-size: 24px">เพิ่มข้อมูลหน่วยนับ</span>
              </div>
              <div class="pa-2">
                <div class="mt-2">
                  <div class="mb-1">
                    ชื่อหน่วยนับ
                  </div>
                  <v-text-field color="#86bc3a" label="ชื่อหน่วยนับ" hide-details="auto" v-model="add_unit.unit_name" :rules="[v => !!v || 'กรุณากรอกชื่อหน่วยนับ']" required outlined></v-text-field>
                </div>
                <div class="mt-2">
                  <div class="mb-1">
                    จำนวนชิ้นย่อยภายใน
                  </div>
                  <v-text-field color="#86bc3a" type="number" pattern="[0-9]*" label="จำนวนชิ้นย่อยภายใน" @keypress="filterKey" v-model="add_unit.unit_qty" hide-details="auto" :rules="[v => !!v || 'กรุณากรอกจำนวนชิ้นย่อยภายใน']" required outlined/>
                </div>
                <div class="text-center mt-3 mb-2">
                  <v-btn large type="submit" class="white--text grad-success-bg btn_size">บันทึกข้อมูล</v-btn>
                </div>
              </div>
            </v-card>
          </v-form>
        </div>
        <div class="margin_left">
          <v-card>
            <div class="pa-4">
              <v-card-title>
                <v-text-field v-model="search" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา" single-line hide-details></v-text-field>
              </v-card-title>
              <v-data-table :headers="headers" :items="dataUnit" :footer-props="footer_Props" :search="search" mobile-breakpoint="0">
                <template v-slot:item="dataDetail" class="grid_btn">
                  <tr>
                    <td>{{ dataDetail.item.name }}</td>
                    <td>{{ dataDetail.item.qty }}</td>
                    <td class="pa-3" v-if="$store.state.userDetail.manage_units_edit === 1">
                      <v-btn small height="42" @click="getEdit(dataDetail.item.id)" class="grad-warning-bg white--text mr-1 mb-1" title="แก้ไข">
                        <v-icon>mdi-note-edit-outline</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </div>
            <v-dialog v-model="edit_Unit" max-width="900">
              <v-card>
                <v-form ref="add_form" @submit.prevent="updateUnit">
                  <v-card-title>
                    แก้ไข้ประเภทสินค้า
                  </v-card-title>

                  <v-card-text>
                    <div>
                      <div class="grid_half">
                        <div class="mt-2">
                          <div class="mb-1">
                            ชื่อหน่วยนับ
                          </div>
                          <v-text-field color="#86bc3a" class="mr-1" label="ชื่อหน่วยนับ"  hide-details="auto" :rules="[v => !!v || 'กรุณากรอกชื่อหน่วยนับ']" required v-model="get_edit.unit_name" outlined></v-text-field>
                        </div>
                        <div class="mt-2">
                          <div class="mb-1">
                            จำนวนชิ้นย่อยภายใน
                          </div>
                          <v-text-field color="#86bc3a" type="number" pattern="[0-9]*" class="mr-1" label="จำนวนชิ้นย่อยภายใน" :rules="[v => !!v || 'กรุณากรอกจำนวนชิ้นย่อยภายใน']" required @keypress="filterKey" v-model="get_edit.unit_qty" hide-details="auto" outlined/>
                        </div>
                      </div>
                    </div>
                  </v-card-text>
                  <v-spacer></v-spacer>
                  <div class="text-center pa-4">
                    <v-btn large class="grad-success-bg white--text mr-3 btn_size" type="submit">
                      บันทึก
                    </v-btn>
                    <v-btn large class="grad-danger-bg white--text btn_size" type="button" @click="edit_Unit = false">
                      ยกเลิก
                    </v-btn>
                  </div>
                </v-form>
              </v-card>
            </v-dialog>
          </v-card>
        </div>
      </div>
      <div class="grid_table_2" v-else>
        <div class="margin_left">
          <v-card>
            <div class="pa-4">
              <v-card-title>
                <v-text-field v-model="search" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา" single-line hide-details></v-text-field>
              </v-card-title>
              <v-data-table :headers="headers" :items="dataUnit" :footer-props="footer_Props" :search="search" mobile-breakpoint="0">
                <template v-slot:item="dataDetail" class="grid_btn">
                  <tr>
                    <td>{{ dataDetail.item.name }}</td>
                    <td>{{ dataDetail.item.qty }}</td>
                    <td class="pa-3" v-if="$store.state.userDetail.manage_units_edit === 1">
                      <v-btn small height="42" @click="getEdit(dataDetail.item.id)" class="grad-warning-bg white--text mr-1 mb-1">
                        <v-icon>mdi-note-edit-outline</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </div>
            <v-dialog v-model="edit_Unit" max-width="900">
              <v-card>
                <v-form ref="add_form" @submit.prevent="updateUnit">
                  <v-card-title>
                    แก้ไข้ประเภทสินค้า
                  </v-card-title>

                  <v-card-text>
                    <div>
                      <div class="grid_half">
                        <div class="mt-2">
                          <div class="mb-1">
                            ชื่อหน่วยนับ
                          </div>
                          <v-text-field color="#86bc3a" class="mr-1" label="ชื่อหน่วยนับ" :rules="[v => !!v || 'กรุณากรอกชื่อหน่วยนับ']" required hide-details="auto" v-model="get_edit.unit_name" outlined></v-text-field>
                        </div>
                        <div class="mt-2">
                          <div class="mb-1">
                            จำนวนชิ้นย่อยภายใน
                          </div>
                          <v-text-field color="#86bc3a" type="number" pattern="[0-9]*" class="mr-1" label="จำนวนชิ้นย่อยภายใน" :rules="[v => !!v || 'กรุณากรอกจำนวนชิ้นย่อยภายใน']" required @keypress="filterKey" v-model="get_edit.unit_qty" hide-details="auto" outlined/>
                        </div>
                      </div>
                    </div>
                  </v-card-text>
                  <v-spacer></v-spacer>
                  <div class="text-center pa-4">
                    <v-btn large class="grad-success-bg white--text mr-3 btn_size" type="submit">
                      บันทึก
                    </v-btn>
                    <v-btn large class="grad-danger-bg white--text btn_size" type="button" @click="edit_Unit = false">
                      ยกเลิก
                    </v-btn>
                  </div>
                </v-form>
              </v-card>
            </v-dialog>
          </v-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {HTTP} from "@/axios.js";
import Swal from "sweetalert2";

export default {
  name: "Unit_Setting",
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  data() {
    return {
      loading_page: false,
      search: null,
      edit_Unit: false,
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      add_unit: {
        unit_id: null,
        unit_name: null,
        unit_qty: null,
      },
      get_edit: {
        unit_name: null,
        unit_qty: null,
      },
      headers: [],
      dataUnit: [],
    }
  },
  methods: {
    filterKey(e){
      const key = e.key;
      // If is '.' key, stop it
      if (key === 'e' || key === '.' || key === '-')
        return e.preventDefault();
    },
    checkLoading() {
      this.loading_page = true
      HTTP.get('/products/units/all')
          .then((res) => {
            if (res.data.success === true){
              this.loading_page = false
              this.dataUnit = res.data.object
            }
          })
    },
    header() {
      if (this.$store.state.userDetail.manage_units_edit == 1) {
        this.headers = [
          // {
          //   text: 'ลำดับ',
          //   value: 'id',
          //   fixed: true,
          //   width: '100px'
          // },
          {
            text: 'ชื่อหน่วยนับ',
            value: 'name',
            fixed: true,
            width: '200px'
          },
          {
            text: 'จำนวนต่อหน่วย',
            value: 'qty',
            fixed: true,
            width: '200px'
          },
          {
            text: 'เมนูจัดการ',
            value: '',
            sortable: false,
            fixed: true,
            width: '150px'
          },
        ]
        return this.headers
      }
      else if (this.$store.state.userDetail.manage_units_edit == 0) {
        this.headers = [
          // {
          //   text: 'ลำดับ',
          //   value: 'id',
          //   fixed: true,
          //   width: '100px'
          // },
          {
            text: 'ชื่อหน่วยนับ',
            value: 'name',
            fixed: true,
            width: '200px'
          },
          {
            text: 'จำนวนต่อหน่วย',
            value: 'qty',
            fixed: true,
            width: '200px'
          },
        ]
        return this.headers
      }
    },
    showAlert() {
      Swal.fire({
        title: 'แก้ไขข้อมูลเรียบร้อย',
        icon: 'success',
        confirmButtonText: 'ตกลง'
      }).then(() => {
        this.edit_Unit = false;
        this.getUnit();
      })
    },
    getUnit(){
      HTTP.get('/products/units/all')
          .then((res) => {
            if (res.data.success === true){
              this.dataUnit = res.data.object
            }
          })
    },
    createUnit(){
      if (this.add_unit.unit_name !== null && this.add_unit.unit_qty !== null && this.add_unit.unit_name !== '' && this.add_unit.unit_qty !== '') {
        HTTP.post('/products/units/create', {
          name: this.add_unit.unit_name,
          qty: this.add_unit.unit_qty
        }).then((res) => {
          if (res.data.success === true){
            this.add_unit.unit_name = null;
            this.add_unit.unit_qty = null;
            Swal.fire('บันทึกข้อมูลเรียบร้อย', '', 'success')
            this.$refs.form.resetValidation()
            this.getUnit();
          } else {
            Swal.fire({
              title: 'ไม่สามารถดำเนินการได้ !',
              text: res.data.message,
              icon: 'error',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: `ตกลง`,
              denyButtonText: `ยกเลิก`,
            })
          }
        })
      }
      else {
        Swal.fire({
          title: 'ไม่สามารถดำเนินการได้ !',
          text: 'กรุณากรอกข้อมูล !',
          icon: 'error',
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        }).then(() => {
          this.$refs.form.validate()
        })
      }
    },
    getEdit(id) {
      this.edit_Unit = true;
      HTTP.post('/products/units/show', {
        id: id
      }).then((res) => {
        if (res.data.success === true){
          this.get_edit.unit_id = res.data.object.id;
          this.get_edit.unit_name = res.data.object.name;
          this.get_edit.unit_qty = res.data.object.qty;
        }
      })
    },
    updateUnit() {
      if (this.get_edit.unit_name !== null && this.get_edit.unit_qty !== null && this.get_edit.unit_name !== '' && this.get_edit.unit_qty !== '') {
        HTTP.post('/products/units/edit', {
          id: this.get_edit.unit_id,
          name: this.get_edit.unit_name,
          qty: this.get_edit.unit_qty,
        }).then((res) => {
          if (res.data.success === true){
            this.showAlert();
          } else {
            Swal.fire({
              title: 'ไม่สามารถดำเนินการได้ !',
              text: res.data.message,
              icon: 'error',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: `ตกลง`,
              denyButtonText: `ยกเลิก`,
            })
          }
        })
      }
      else {
        Swal.fire({
          title: 'ไม่สามารถดำเนินการได้ !',
          text: 'กรุณากรอกข้อมูล !',
          icon: 'error',
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        }).then(() => {
          this.$refs.add_form.validate()
        })
      }
    },
  },
  beforeMount() {
    // this.checkLogIn();
    this.checkLoading();
  },
  mounted() {
    this.header();
  }
}
</script>

<style scoped>
.grid_table_2 {
  display: grid;
  grid-template-columns: 100%;
}
.grid_table {
  display: grid;
  grid-template-columns: 40% 60%;
}
.btn_size {
  font-size: 18px;
}
.margin_right {
  margin-right: 40px;
}
.margin_left {
  margin-right: 10px;
}
@media only screen and (max-width: 1100px) {
  .grid_table {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 20px 0;
  }
  .margin_right {
    margin-right: 0;
  }
  .margin_left {
    margin-right: 0;
  }
}
</style>
